import { classNames } from "@/utility/jsx";
import { Checkbox as MetxCheckbox } from "@mm/metx-design-system";
import type { ComponentProps } from "react";

export function Checkbox({ className, ...props }: ComponentProps<typeof MetxCheckbox>) {
  return <MetxCheckbox {...props} className={classNames("mm-checkbox", className)} />;
}
